export * from './AiAgent';
export * from './commercialFeatureFlags';
export * from './embed';
export * from './scim/errors';
export * from './scim/types';
export * from './serviceAccounts/types';
export var ScimSchemaType;
(function (ScimSchemaType) {
    ScimSchemaType["ERROR"] = "urn:ietf:params:scim:api:messages:2.0:Error";
    ScimSchemaType["USER"] = "urn:ietf:params:scim:schemas:core:2.0:User";
    ScimSchemaType["GROUP"] = "urn:ietf:params:scim:schemas:core:2.0:Group";
    ScimSchemaType["ROLE"] = "urn:ietf:params:scim:schemas:extension:2.0:Role";
    ScimSchemaType["LIST_RESPONSE"] = "urn:ietf:params:scim:api:messages:2.0:ListResponse";
    ScimSchemaType["SCHEMA"] = "urn:ietf:params:scim:schemas:core:2.0:Schema";
    ScimSchemaType["PATCH"] = "urn:ietf:params:scim:api:messages:2.0:PatchOp";
    ScimSchemaType["LIGHTDASH_USER_EXTENSION"] = "urn:lightdash:params:scim:schemas:extension:2.0:User";
    ScimSchemaType["SERVICE_PROVIDER_CONFIG"] = "urn:ietf:params:scim:schemas:core:2.0:ServiceProviderConfig";
    ScimSchemaType["RESOURCE_TYPE"] = "urn:ietf:params:scim:schemas:core:2.0:ResourceType";
})(ScimSchemaType || (ScimSchemaType = {}));
//# sourceMappingURL=index.js.map